import React from "react";
import "../css/productimage.scss";

function ProductImage({
  product,
  className = "",
  ariaLabel,
  decorative = false,
}) {
  if (!product) return null;

  const classes = ["catalog-product-image", className]
    .filter(Boolean)
    .join(" ");

  return (
    <span
      className={classes}
      style={{
        backgroundImage: `url(${product.image})`,
        backgroundPosition: product.imagePosition || "center",
        backgroundSize: product.imageSize || "cover",
      }}
      role={decorative ? undefined : "img"}
      aria-hidden={decorative ? "true" : undefined}
      aria-label={decorative ? undefined : ariaLabel || product.name}
    />
  );
}

export default ProductImage;
